export default __webpack_public_path__ + "static/media/StartNow.7ac6da69.png";